const countriesIsoCodes = {
  Algeria: { iso2: "DZ", iso3: "DZA" },
  Angola: { iso2: "AO", iso3: "AGO" },
  Benin: { iso2: "BJ", iso3: "BEN" },
  Botswana: { iso2: "BW", iso3: "BWA" },
  "Burkina Faso": { iso2: "BF", iso3: "BFA" },
  Burundi: { iso2: "BI", iso3: "BDI" },
  Cameroon: { iso2: "CM", iso3: "CMR" },
  "Cape Verde": { iso2: "CV", iso3: "CPV" },
  "Central African Republic": { iso2: "CF", iso3: "CAF" },
  Comoros: { iso2: "KM", iso3: "COM" },
  "Democratic Republic of Congo": { iso2: "CD", iso3: "COD" },
  "Congo, Democratic Republic of the": { iso2: "CD", iso3: "COD" },
  Djibouti: { iso2: "DJ", iso3: "DJI" },
  Egypt: { iso2: "EG", iso3: "EGY" },
  "Equatorial Guinea": { iso2: "GQ", iso3: "GNQ" },
  Eritrea: { iso2: "ER", iso3: "ERI" },
  Ethiopia: { iso2: "ET", iso3: "ETH" },
  Gabon: { iso2: "GA", iso3: "GAB" },
  Gambia: { iso2: "GM", iso3: "GMB" },
  Ghana: { iso2: "GH", iso3: "GHA" },
  Guinea: { iso2: "GN", iso3: "GIN" },
  "Guinea-Bissau": { iso2: "GW", iso3: "GNB" },
  "Ivory Coast": { iso2: "CI", iso3: "CIV" },
  "Côte d'Ivoire": { iso2: "CI", iso3: "CIV" },
  Kenya: { iso2: "KE", iso3: "KEN" },
  Chad: { iso2: "TD", iso3: "TCD" },
  Lesotho: { iso2: "LS", iso3: "LSO" },
  Liberia: { iso2: "LR", iso3: "LBR" },
  Libya: { iso2: "LY", iso3: "LBY" },
  Madagascar: { iso2: "MG", iso3: "MDG" },
  Malawi: { iso2: "MW", iso3: "MWI" },
  Mali: { iso2: "ML", iso3: "MLI" },
  Mauritania: { iso2: "MR", iso3: "MRT" },
  Mauritius: { iso2: "MU", iso3: "MUS" },
  Morocco: { iso2: "MA", iso3: "MAR" },
  Mozambique: { iso2: "MZ", iso3: "MOZ" },
  Namibia: { iso2: "NA", iso3: "NAM" },
  Niger: { iso2: "NE", iso3: "NER" },
  Nigeria: { iso2: "NG", iso3: "NGA" },
  "Republic of the Congo": { iso2: "CG", iso3: "COG" },
  Reunion: { iso2: "RE", iso3: "REU" },
  Rwanda: { iso2: "RW", iso3: "RWA" },
  "Saint Helena": { iso2: "SH", iso3: "SHN" },
  "Sao Tome and Principe": { iso2: "ST", iso3: "STP" },
  Senegal: { iso2: "SN", iso3: "SEN" },
  Seychelles: { iso2: "SC", iso3: "SYC" },
  "Sierra Leone": { iso2: "SL", iso3: "SLE" },
  Somalia: { iso2: "SO", iso3: "SOM" },
  "South Africa": { iso2: "ZA", iso3: "ZAF" },
  "South Sudan": { iso2: "SS", iso3: "SSD" },
  Sudan: { iso2: "SD", iso3: "SDN" },
  Swaziland: { iso2: "SZ", iso3: "SWZ" },
  Tanzania: { iso2: "TZ", iso3: "TZA" },
  Togo: { iso2: "TG", iso3: "TGO" },
  Tunisia: { iso2: "TN", iso3: "TUN" },
  Uganda: { iso2: "UG", iso3: "UGA" },
  "Western Sahara": { iso2: "EH", iso3: "ESH" },
  Zambia: { iso2: "ZM", iso3: "ZMB" },
  Zimbabwe: { iso2: "ZW", iso3: "ZWE" },
};

const dealRanges = [
  { name: "Under $1m", value: "00000_00001" },
  { name: "$1m - $5m", value: "00001_00005" },
  { name: "$5m - $20m", value: "00005_00020" },
  { name: "$20m - $100m", value: "00020_00100" },
  { name: "Over $100m", value: "00100_99999" },
];

const materialsAvailableOptions = [
  {
    value: "investmentDeck",
    label: "Investment deck",
  },
  {
    value: "financialStatements",
    label: "Financial statements",
  },
  {
    value: "marketStudies",
    label: "Market studies",
  },
  {
    value: "preliminaryStudy",
    label: "Preliminary study",
  },
  {
    value: "prefeasibilityStudy",
    label: "Pre-feasibility studies",
  },
  {
    value: "feasibilityStudy",
    label: "Feasibility studies",
  },
  {
    value: "restructuringPlan",
    label: "Restructuring plan",
  },
  {
    value: "rolloutPlan",
    label: "Roll-out plan",
  },
  {
    value: "informationMemorandum",
    label: "Information Memorandum",
  },
  {
    value: "termSheet",
    label: "Term Sheet",
  },
  {
    value: "dueDiligenceReport",
    label: "Due Diligence Report",
  },
  {
    value: "dueDiligenceQuestionnaire",
    label: "Due Diligence Questionnaire",
  },
  {
    value: "businessPlan",
    label: "Business Plan",
  },
  {
    value: "financialModel",
    label: "Financial Model",
  },
  {
    value: "executiveBrief",
    label: "Executive Brief",
  },
  {
    value: "dataRoom",
    label: "Data Room",
  },
  {
    value: "goToMarketStrategy",
    label: "Go-to-market Strategy",
  },
  {
    value: "companyPresentation",
    label: "Company Presentation",
  },
  {
    value: "subscriptionAgreement",
    label: "Subscription Agreement",
  },
  {
    value: "investmentTeaser",
    label: "Investment Teaser",
  },
  {
    value: "PPM",
    label: "PPM",
  },
  {
    value: "fundModel",
    label: "Fund Model",
  },
  {
    value: "factSheet",
    label: "Fact Sheet",
  },
];

export default {
  countriesIsoCodes,
  dealRanges,
  materialsAvailableOptions,
};
